"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IncomeTaxScheme = (function () {
    function IncomeTaxScheme() {
        this._bandsArray = [];
        this._ratesArray = [];
    }
    IncomeTaxScheme.prototype.addBand = function (bandStart, rate) {
        this._bandsArray.push(bandStart);
        this._ratesArray.push(rate);
    };
    IncomeTaxScheme.prototype.bandStartAtIndex = function (index) {
        return this._bandsArray[index - 1];
    };
    IncomeTaxScheme.prototype.rateAtIndex = function (index) {
        return this._ratesArray[index - 1];
    };
    Object.defineProperty(IncomeTaxScheme.prototype, "numberOfBands", {
        get: function () {
            return this._bandsArray.length;
        },
        enumerable: true,
        configurable: true
    });
    return IncomeTaxScheme;
}());
exports.IncomeTaxScheme = IncomeTaxScheme;
//# sourceMappingURL=IncomeTaxScheme.js.map